import Toolbar from "@mui/material/Toolbar";
import Head from "next/head";
import React, { Fragment } from "react";
import ToResolveClassNameError from "../../components/hoc/ToResolveClassNameError";
import CompanyJobsContent from "../../components/job-search/CompanyJobsContent/CompanyJobsContent";
import SharedFooter from "../../components/shared/SharedFooter/SharedFooter";
import SharedNavbar2 from "../../components/shared/SharedNavbar/Navbar/Navbar";
import * as config from "../../config/config";
import { getCompaniesForSitemap } from "../../redux/actions/company_action";

function JobsByCompany(props) {
  const { featuredCompanies = [] } = props;

  const metaTitle = "Jobs by Company - Hiredly - Find Jobs in Malaysia";
  const metaDescription =
    "Jobs by Company - Hiredly. Find full time, internship and work from home jobs in Malaysia. Upload your resume and let our headhunters find a job vacancy for you.";

  return (
    <Fragment>
      <Head>
        {/* <!-- Primary Meta Tags --> */}
        <title>{metaTitle}</title>
        <meta name="title" content={metaTitle} />
        <meta name="description" content={metaDescription} />

        {/* <!-- Open Graph / Facebook --> */}
        <meta property="og:type" content="website" key={"ogType"} />
        <meta
          property="og:url"
          content="https://my.hiredly.com/sitemap/jobs-by-company"
          key="ogUrl"
        />
        <meta property="og:title" content={metaTitle} key="ogTitle" />
        <meta
          property="og:description"
          content={metaDescription}
          key="ogDescription"
        />
        <meta
          property="og:image"
          content={
            config.assetDomain + "/images/hiredly/hiredly-meta-image-v1.png"
          }
          key="ogImage"
        />

        {/* <!-- Twitter --> */}
        <meta
          property="twitter:card"
          content="summary_large_image"
          key="twitterCard"
        />
        <meta
          property="twitter:url"
          content="https://my.hiredly.com/sitemap/jobs-by-company"
          key="twitterUrl"
        />
        <meta property="twitter:title" content={metaTitle} key="twitterTitle" />
        <meta
          property="twitter:description"
          content={metaDescription}
          key="twitterDescription"
        />
        <meta
          property="twitter:image"
          content={
            config.assetDomain + "/images/hiredly/hiredly-meta-image-v1.png"
          }
          key="twitterImage"
        />
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width"
        />
        <link
          rel="canonical"
          href="https://my.hiredly.com/sitemap/jobs-by-company"
        />
      </Head>
      <ToResolveClassNameError>
        <SharedNavbar2 />
      </ToResolveClassNameError>

      <CompanyJobsContent companies={featuredCompanies} />

      <Toolbar />

      <SharedFooter />
    </Fragment>
  );
}

export async function getStaticProps() {
  const companies = await getCompaniesForSitemap({
    canCancel: false,
    responseTimeout: 100000,
  });

  const filteredCompanies =
    companies && Array.isArray(companies)
      ? (() => {
          const PRIORITY_KEYWORDS = [
            "hiredly",
            "uniqlo",
            "storehub",
            "canon",
            "ocbc",
            "silverlake",
            "zus-coffee",
            "agoda",
            "grab",
            "shopee",
            "singapore-airline",
            "forvis-mazars",
            "ninja-van",
          ];

          // Step 1: Get the priority companies
          const priorityCompanies = companies.filter((company) =>
            PRIORITY_KEYWORDS.some((keyword) =>
              company?.slug?.toLowerCase().includes(keyword)
            )
          );

          // Step 2: Get the rest of the companies
          const remainingCompanies = companies.filter(
            (company) =>
              !priorityCompanies.some(
                (prioritized) => prioritized.slug === company?.slug
              )
          );

          // Step 3: Merge and take up to 21
          return [...priorityCompanies, ...remainingCompanies].slice(0, 36);
        })()
      : [];

  return {
    props: {
      featuredCompanies: filteredCompanies || [],
    },
    revalidate: 86400,
  };
}

export default JobsByCompany;
